import { render } from "./ServiceAlert.vue?vue&type=template&id=5ef15df4"
import script from "./ServiceAlert.vue?vue&type=script&lang=js"
export * from "./ServiceAlert.vue?vue&type=script&lang=js"

import "./ServiceAlert.vue?vue&type=style&index=0&id=5ef15df4&lang=css"

import exportComponent from "/home/forge/prod-v5.valleymetro.org/releases/81890031/resources/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__